import React, { useCallback, useEffect } from "react";
// import "@shopify/polaris/build/esm/styles.css";
import {
  BrowserRouter,
  Routes, // instead of "Switch"
  Route,
} from "react-router-dom";
import { AppProvider, Toast } from "@shopify/polaris";
import "./Assets/Styles/globals.css";
import "./Assets/Styles/react-tagsinput.css";
import Login from "./Pages/Authentication/Login";
import ForgotPassword from "./Pages/Authentication/ForgotPassword";
import Profile from "./Pages/Profile";
import ResetPassword from "./Pages/Authentication/ResetPassword";
import NavigationLayout from "./Components/NavigationLayout";
// import "bootstrap/dist/css/bootstrap.css";
import Pages from "./Pages/PagesSection/List";
import AddPage from "./Pages/PagesSection/Add";
import EditPage from "./Pages/PagesSection/Edit";
import Languages from "./Settings/Languages";
import UsersAndPermissions from "./Settings/UsersAndPermissions";
import ContactInformation from "./Settings/ContactInformation";
import AccessPassword from "./Settings/AccessPassword";
import Brand from "./Settings/Brand";
import Sections from "./Pages/PagesSection/Sections";
import Translations from "./Pages/UIText/Translations";
import Dashboard from "./Pages/Dashboard";
import GridView from "./Settings/Integrations/Grid";
import ShopifyDomain from "./Settings/Integrations/ShopifyDomain";
import GoogleAnalytics from "./Settings/Integrations/GoogleAnalytics";
import Navigation from "./Pages/Navigation/Navigation";
import AddMenu from "./Pages/Navigation/AddMenu";
import EditMenu from "./Pages/Navigation/EditMenu";
import Channels from "./Settings/Channels";
import Contacts from "./Pages/CRM/Contacts/List";
import ContactDetails from "./Pages/CRM/Contacts/ContactDetails";
import Companies from "./Pages/CRM/Companies/List";
import { AddContact } from "./Pages/CRM/Contacts/AddContact";
import Categories from "./Pages/CRM/Categories/List";
import Statuses from "./Pages/CRM/Statuses/List";
import { EditContact } from "./Pages/CRM/Contacts/EditContact";
import Campaigns from "./Pages/CRM/Campaigns/List";
import Board from "./Pages/CRM/Board";
import Bookmarks from "./Settings/Bookmarks";
import SectionsCustomization from "./Settings/SectionsCustomization";
import Templates from "./Settings/Templates";
import Deals from "./Pages/CRM/Deals/List";
import { AddDeal } from "./Pages/CRM/Deals/AddDeal";
import DealStages from "./Pages/CRM/DealStages/List";
import DealsBoard from "./Pages/CRM/Deals/Board";
import { EditDeal } from "./Pages/CRM/Deals/EditDeal";
import Projects from "./Pages/Projects/List";
import AddEditProject from "./Pages/Projects/AddEdit";
import { AddWorkflow } from "./Pages/CRM/Automation/AddWorkflow";
import Workflows from "./Pages/CRM/Automation/List";
import { EditWorkflow } from "./Pages/CRM/Automation/EditWorkflow";
import AppSettings from "./Settings/AppSettings";
import PagesTags from "./Settings/PagesTags";
import Portfolio from "./Pages/Portfolio/List";
import AddEditPortfolio from "./Pages/Portfolio/AddEdit";
import Gallery from "./Pages/Portfolio/Gallery/List";
import AddEditGallery from "./Pages/Portfolio/Gallery/AddEdit";
import Products from "./Pages/Products/List";
import AddEditProduct from "./Pages/Products/AddEdit";
import CategoriesProducts from "./Pages/Products/Categories/List";
import AddEditCategories from "./Pages/Products/Categories/AddEdit";
import Tags from "./Pages/Products/Tags/List";
import AddEditTag from "./Pages/Products/Tags/AddEdit";
import ProjectsInnovest from "./Pages/ProjectsInnovest/List";
import AddEditProjectInnovest from "./Pages/ProjectsInnovest/AddEdit";
import Countries from "./Pages/Portfolio/Countries/List";
import AddEditCountry from "./Pages/Portfolio/Countries/AddEdit";
import CategoriesPortfolio from "./Pages/Portfolio/Categories/List";
import AddEditCategoryPortfolio from "./Pages/Portfolio/Categories/AddEdit";
import GalleryInnovest from "./Pages/ProjectsInnovest/Gallery/List";
import AddEditGalleryInnovest from "./Pages/ProjectsInnovest/Gallery/AddEdit";
import DeployNetlify from "./Pages/Deploy/DeployNetlify";
import Talent from "./Pages/Mindset/Team/List";
import AddEditTalent from "./Pages/Mindset/Team/AddEdit";
import AddEditCategoriesTalent from "./Pages/Mindset/Team/Categories/AddEdit";
import CategoriesTalent from "./Pages/Mindset/Team/Categories/List";
import TagsTalent from "./Pages/Mindset/Team/Tags/List";
import AddEditTagsTalent from "./Pages/Mindset/Team/Tags/AddEdit";
import OtpActivities from "./Pages/OTPActivities/List";
import Competitors from "./Pages/Competitors/List";
import AddEditCompetitor from "./Pages/Competitors/AddEdit";
import {
  useRoutes, // instead of "Switch"
} from "react-router-dom";
import Screenshots from "./Pages/Competitors/Screenshots/List";
import AddEditScreenshot from "./Pages/Competitors/Screenshots/AddEdit";
import Personas from "./Pages/Personas/List";
import AddEditPersona from "./Pages/Personas/AddEdit";
import Goals from "./Pages/Goals/List";
import AddEditGoal from "./Pages/Goals/AddEdit";
import Achievements from "./Pages/Achievements/List";
import Tasks from "./Pages/Goals/Tasks/List";
import AddEditTask from "./Pages/Goals/Tasks/AddEdit";
import AddEditAchievement from "./Pages/Achievements/AddEdit";
import TimelinePage from "./Pages/Goals/TimelinePage";
import Benchmark from "./Pages/Benchmark/List";
import Benchmarks from "./Pages/Benchmark/List";
import AddEditBenchmark from "./Pages/Benchmark/AddEdit";
import Metrics from "./Pages/Benchmark/Metrics";
import BenchmarkCategories from "./Pages/Benchmark/Categories/List";
import BenchmarkSubcategories from "./Pages/Benchmark/Subcategories/List";
import People from "./Pages/People/List";
import AddEditUser from "./Pages/People/AddEdit";
import Departments from "./Pages/People/Departments/List";
import TagsPersonas from "./Pages/Personas/Tags/List";
import BrandBenchmark from "./Pages/BrandBenchmark/List";
import AddEditBrandBenchmark from "./Pages/BrandBenchmark/AddEdit";
import CountriesSettings from "./Pages/Countries";
import TaskManager from "./Pages/TaskManager/List";
import ImagesGoal from "./Pages/Goals/Images/List";
import AddEditImageGoal from "./Pages/Goals/Images/AddEdit";
import CriteriasBenchmark from "./Pages/BrandBenchmark/Criterias/List";
import BrandBenchmarkCategories from "./Pages/BrandBenchmark/Categories/List";
import ImagesBechmark from "./Pages/BrandBenchmark/Images/List";
import AddEditImageBechmark from "./Pages/BrandBenchmark/Images/AddEdit";
import ProjectsGrid from "./Pages/ProjectsGrowth/List";
import MainProjects from "./Pages/ProjectsGrowth/Main";
import ProjectAddEdit from "./Pages/ProjectsGrowth/AddEdit";
import ProjectTypes from "./Pages/ProjectsGrowth/Types/List";
import TaskManagerMain from "./Pages/TaskManager/Main";
import Teams from "./Pages/Team/Main";
import AddEditTaskManager from "./Pages/TaskManager/AddEdit";
import ProjectTaskManagerAddEdit from "./Pages/TaskManager/Projects/AddEdit";
import ProjectsTaskManagerCategories from "./Pages/TaskManager/Categories/List";
import ProjectsTaskManagerStatuses from "./Pages/TaskManager/Statuses/List";
import TaskManagerProjects from "./Pages/TaskManager/Projects/List";
import ProjectsList from "./Pages/TaskManager/Projects/ProjectsList";
function getFaviconEl() {
  return document.getElementById("favicon");
}

function App() {
  if (process.env.NODE_ENV === "production") {
    console.log = function () {};
  }
  // useEffect(() => {
  //   document.title = `${process.env.REACT_APP_CLIENT_NAME} - Admin Panel`;
  //   const favicon = getFaviconEl();
  //   favicon.href = `${process.env.REACT_APP_CLIENT}-favicon.ico`;
  // }, []);
  useEffect(() => {
    const title = `${process.env.REACT_APP_CLIENT_NAME} - Admin Panel`;
    document.title = title;

    const faviconPath = `/${process.env.REACT_APP_CLIENT}-favicon.ico`;

    // Try to find an existing <link rel="icon"> tag or create one
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    // Bust browser cache by adding a query param based on timestamp
    link.href = `${faviconPath}?v=${Date.now()}`;
  }, []);
  // useEffect(() => {
  //   document.title = `${process.env.REACT_APP_CLIENT_NAME} - Admin Panel`;
  //   const favicon = document.getElementById("favicon");
  //   if (favicon) {
  //     favicon.href = `/${process.env.REACT_APP_CLIENT}-favicon.ico`;
  //   }
  // }, []);
  return useRoutes([
    { path: "/", element: <Login /> },
    { path: "/profile", element: <Profile /> },
    { path: "/forgotpassword", element: <ForgotPassword /> },
    { path: "/password/reset", element: <ResetPassword /> },

    // Settings
    {
      path: "/admin/settings/social-media-and-links",
      element: (
        <NavigationLayout>
          <Translations
            type="social"
            title="Social Media and Links"
            tableTitle1="Name"
            tableTitle2="Url"
            url="settings/social"
          />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/languages",
      element: (
        <NavigationLayout>
          <Languages />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/channels",
      element: (
        <NavigationLayout>
          <Channels />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/pages-tags",
      element: (
        <NavigationLayout>
          <PagesTags />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/templates",
      element: (
        <NavigationLayout>
          <Templates />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/bookmarks",
      element: (
        <NavigationLayout>
          <Bookmarks />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/users-and-permissions",
      element: (
        <NavigationLayout>
          <UsersAndPermissions />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/brand",
      element: (
        <NavigationLayout>
          <Brand />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/contact-information",
      element: (
        <NavigationLayout>
          <ContactInformation />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/google-analytics-account",
      element: (
        <NavigationLayout>
          <GoogleAnalytics />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/access-password",
      element: (
        <NavigationLayout>
          <AccessPassword />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/integrations",
      element: (
        <NavigationLayout>
          <GridView />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/integrations/shopify-domain",
      element: (
        <NavigationLayout>
          <ShopifyDomain />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/integrations/google-analytics",
      element: (
        <NavigationLayout>
          <GoogleAnalytics />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/sections-customization",
      element: (
        <NavigationLayout>
          <SectionsCustomization />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/app-settings",
      element: (
        <NavigationLayout>
          <AppSettings />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/deploy",
      element: (
        <NavigationLayout>
          <DeployNetlify />
        </NavigationLayout>
      ),
    },

    // UI Text
    {
      path: "/admin/ui-text",
      element: (
        <NavigationLayout>
          <Translations
            type="ui"
            title="UI Text"
            tableTitle1="Key"
            tableTitle2="Value"
            url="translations"
          />
        </NavigationLayout>
      ),
    },

    // Pages, Blogs, Careers
    {
      path: "/admin/pages",
      element: (
        <NavigationLayout>
          <Pages pageKey="pages" type="pages" title="Pages" button="Add Page" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/pages/new",
      element: (
        <NavigationLayout>
          <AddPage type="pages" title="Add Page" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/pages/:id",
      element: (
        <NavigationLayout>
          <EditPage type="pages" title="Edit Page" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/pages/:id/sections",
      element: (
        <NavigationLayout>
          <Sections type="pages" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/blogs",
      element: (
        <NavigationLayout>
          <Pages pageKey="blogs" type="blogs" title="Blogs" button="Add Blog" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/blogs/new",
      element: (
        <NavigationLayout>
          <AddPage type="blogs" title="Add Blog" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/blogs/:id",
      element: (
        <NavigationLayout>
          <EditPage type="blogs" title="Edit Blog" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/blogs/:id/sections",
      element: (
        <NavigationLayout>
          <Sections type="blogs" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/careers",
      element: (
        <NavigationLayout>
          <Pages
            pageKey="careers"
            type="careers"
            title="Careers"
            button="Add Career"
          />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/careers/new",
      element: (
        <NavigationLayout>
          <AddPage type="careers" title="Add Career" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/careers/:id",
      element: (
        <NavigationLayout>
          <EditPage type="careers" title="Edit Career" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/careers/:id/sections",
      element: (
        <NavigationLayout>
          <Sections type="careers" />
        </NavigationLayout>
      ),
    },

    // Dashboard
    {
      path: "/admin/dashboard",
      element: (
        <NavigationLayout>
          <Dashboard />
        </NavigationLayout>
      ),
    },

    // Navigation
    {
      path: "/admin/navigation",
      element: (
        <NavigationLayout>
          <Navigation />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/navigation/add-menu",
      element: (
        <NavigationLayout>
          <AddMenu />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/navigation/:id",
      element: (
        <NavigationLayout>
          <EditMenu />
        </NavigationLayout>
      ),
    },

    // CRM Contacts
    {
      path: "/admin/crm/contacts",
      element: (
        <NavigationLayout>
          <Contacts />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/contacts/new",
      element: (
        <NavigationLayout>
          <AddContact />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/contacts/:id",
      element: (
        <NavigationLayout>
          <EditContact />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/contacts/categories",
      element: (
        <NavigationLayout>
          <Categories />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/contacts/statuses",
      element: (
        <NavigationLayout>
          <Statuses />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/contacts/companies",
      element: (
        <NavigationLayout>
          <Companies />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/contacts/board",
      element: (
        <NavigationLayout>
          <Board />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/tags",
      element: (
        <NavigationLayout>
          <Contacts />
        </NavigationLayout>
      ),
    },

    // CRM Deals
    {
      path: "/admin/crm/deals",
      element: (
        <NavigationLayout>
          <Deals />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/deals/new",
      element: (
        <NavigationLayout>
          <AddDeal />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/deals/:id",
      element: (
        <NavigationLayout>
          <EditDeal />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/deals/stages",
      element: (
        <NavigationLayout>
          <DealStages />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/deals/board",
      element: (
        <NavigationLayout>
          <DealsBoard />
        </NavigationLayout>
      ),
    },

    // CRM Campaigns
    {
      path: "/admin/crm/campaigns",
      element: (
        <NavigationLayout>
          <Campaigns />
        </NavigationLayout>
      ),
    },

    // CRM Automation
    {
      path: "/admin/crm/automation",
      element: (
        <NavigationLayout>
          <Workflows />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/automation/new",
      element: (
        <NavigationLayout>
          <AddWorkflow />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/crm/automation/:id",
      element: (
        <NavigationLayout>
          <EditWorkflow />
        </NavigationLayout>
      ),
    },

    // Projects
    // {
    //   path: "/admin/projects",
    //   element: (
    //     <NavigationLayout>
    //       <Projects />
    //     </NavigationLayout>
    //   ),
    // },
    // {
    //   path: "/admin/projects/new",
    //   element: (
    //     <NavigationLayout>
    //       <AddEditProject type="add" />
    //     </NavigationLayout>
    //   ),
    // },
    // {
    //   path: "/admin/projects/:id",
    //   element: (
    //     <NavigationLayout>
    //       <AddEditProject type="edit" />
    //     </NavigationLayout>
    //   ),
    // },

    // Portfolio Countries & Categories
    {
      path: "/admin/portfolio/countries",
      element: (
        <NavigationLayout>
          <Countries />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/portfolio/countries/new",
      element: (
        <NavigationLayout>
          <AddEditCountry type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/portfolio/countries/:countryId",
      element: (
        <NavigationLayout>
          <AddEditCountry type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/portfolio/categories",
      element: (
        <NavigationLayout>
          <CategoriesPortfolio />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/portfolio/categories/new",
      element: (
        <NavigationLayout>
          <AddEditCategoryPortfolio type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/portfolio/categories/:categoryId",
      element: (
        <NavigationLayout>
          <AddEditCategoryPortfolio type="edit" />
        </NavigationLayout>
      ),
    },

    // Projects Innovest
    {
      path: "/admin/projects-innovest",
      element: (
        <NavigationLayout>
          <ProjectsInnovest />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/projects-innovest/new",
      element: (
        <NavigationLayout>
          <AddEditProjectInnovest type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/projects-innovest/:id",
      element: (
        <NavigationLayout>
          <AddEditProjectInnovest type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/projects-innovest/:id/gallery",
      element: (
        <NavigationLayout>
          <GalleryInnovest />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/projects-innovest/:id/gallery/new",
      element: (
        <NavigationLayout>
          <AddEditGalleryInnovest type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/projects-innovest/:id/gallery/:galleryId",
      element: (
        <NavigationLayout>
          <AddEditGalleryInnovest type="edit" />
        </NavigationLayout>
      ),
    },

    // Portfolio
    {
      path: "/admin/portfolio",
      element: (
        <NavigationLayout>
          <Portfolio />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/portfolio/new",
      element: (
        <NavigationLayout>
          <AddEditPortfolio type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/portfolio/:id",
      element: (
        <NavigationLayout>
          <AddEditPortfolio type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/portfolio/:id/gallery",
      element: (
        <NavigationLayout>
          <Gallery />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/portfolio/:id/gallery/new",
      element: (
        <NavigationLayout>
          <AddEditGallery type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/portfolio/:id/gallery/:galleryId",
      element: (
        <NavigationLayout>
          <AddEditGallery type="edit" />
        </NavigationLayout>
      ),
    },

    // Products
    {
      path: "/admin/products",
      element: (
        <NavigationLayout>
          <Products />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/products/new",
      element: (
        <NavigationLayout>
          <AddEditProduct type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/products/:id",
      element: (
        <NavigationLayout>
          <AddEditProduct type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/products/categories",
      element: (
        <NavigationLayout>
          <CategoriesProducts />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/products/categories/new",
      element: (
        <NavigationLayout>
          <AddEditCategories type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/products/categories/:id",
      element: (
        <NavigationLayout>
          <AddEditCategories type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/products/tags",
      element: (
        <NavigationLayout>
          <Tags />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/products/tags/new",
      element: (
        <NavigationLayout>
          <AddEditTag type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/products/tags/:id",
      element: (
        <NavigationLayout>
          <AddEditTag type="edit" />
        </NavigationLayout>
      ),
    },

    // Talent
    {
      path: "/admin/talent",
      element: (
        <NavigationLayout>
          <Talent />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/talent/new",
      element: (
        <NavigationLayout>
          <AddEditTalent type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/talent/:id",
      element: (
        <NavigationLayout>
          <AddEditTalent type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/talent/categories",
      element: (
        <NavigationLayout>
          <CategoriesTalent />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/talent/categories/new",
      element: (
        <NavigationLayout>
          <AddEditCategoriesTalent type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/talent/categories/:id",
      element: (
        <NavigationLayout>
          <AddEditCategoriesTalent type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/talent/tags",
      element: (
        <NavigationLayout>
          <TagsTalent />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/talent/tags/new",
      element: (
        <NavigationLayout>
          <AddEditTagsTalent type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/talent/tags/:id",
      element: (
        <NavigationLayout>
          <AddEditTagsTalent type="edit" />
        </NavigationLayout>
      ),
    },

    // OTP Activities
    {
      path: "/admin/otp-activities",
      element: (
        <NavigationLayout>
          <OtpActivities />
        </NavigationLayout>
      ),
    },

    // Competitors
    {
      path: "/admin/competitors",
      element: (
        <NavigationLayout>
          <Competitors />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/competitors/new",
      element: (
        <NavigationLayout>
          <AddEditCompetitor mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/competitors/:id",
      element: (
        <NavigationLayout>
          <AddEditCompetitor mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/competitors/:id/screenshots",
      element: (
        <NavigationLayout>
          <Screenshots />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/competitors/:id/screenshots/new",
      element: (
        <NavigationLayout>
          <AddEditScreenshot mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/competitors/:id/screenshots/:screenshotId",
      element: (
        <NavigationLayout>
          <AddEditScreenshot mode="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/personas",
      element: (
        <NavigationLayout>
          <Personas />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/personas/new",
      element: (
        <NavigationLayout>
          <AddEditPersona mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/personas/:id",
      element: (
        <NavigationLayout>
          <AddEditPersona mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/personas/edit/tags",
      element: (
        <NavigationLayout>
          <TagsPersonas />
        </NavigationLayout>
      ),
    },
    // Catch all 404
    {
      path: "*",
      element: (
        <NavigationLayout>
          <h1>404 Not Found</h1>
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/competitors",
      element: (
        <NavigationLayout>
          <Competitors />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/competitors/new",
      element: (
        <NavigationLayout>
          <AddEditCompetitor mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/competitors/:id",
      element: (
        <NavigationLayout>
          <Competitors mode="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/goals",
      element: (
        <NavigationLayout>
          <Goals />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/goals/new",
      element: (
        <NavigationLayout>
          <AddEditGoal mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/goals/:id",
      element: (
        <NavigationLayout>
          <AddEditGoal mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/goals/:id/tasks",
      element: (
        <NavigationLayout>
          <Tasks />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/goals/:id/tasks/new",
      element: (
        <NavigationLayout>
          <AddEditTask mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/goals/:id/tasks/:taskId",
      element: (
        <NavigationLayout>
          <AddEditTask mode="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/goals/:id/images",
      element: (
        <NavigationLayout>
          <ImagesGoal />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/goals/:id/images/new",
      element: (
        <NavigationLayout>
          <AddEditImageGoal mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/goals/:id/images/:screenshotId",
      element: (
        <NavigationLayout>
          <AddEditImageGoal mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/goals/:id/images/:taskId",
      element: (
        <NavigationLayout>
          <AddEditImageGoal mode="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/achievements",
      element: (
        <NavigationLayout>
          <Achievements />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/achievements/new",
      element: (
        <NavigationLayout>
          <AddEditAchievement mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/achievements/:id",
      element: (
        <NavigationLayout>
          <AddEditAchievement mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/goals/timeline",
      element: (
        <NavigationLayout>
          <TimelinePage />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/benchmarks",
      element: (
        <NavigationLayout>
          <Benchmarks />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/benchmarks/new",
      element: (
        <NavigationLayout>
          <AddEditBenchmark mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/benchmarks/:id",
      element: (
        <NavigationLayout>
          <AddEditBenchmark mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/benchmarks/:id/metrics",
      element: (
        <NavigationLayout>
          <Metrics />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/benchmarks/edit/categories",
      element: (
        <NavigationLayout>
          <BenchmarkCategories />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/benchmarks/edit/categories/:id/subcategories",
      element: (
        <NavigationLayout>
          <BenchmarkSubcategories />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/people",
      element: (
        <NavigationLayout>
          <People />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/people/new",
      element: (
        <NavigationLayout>
          <AddEditUser mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/people/:id",
      element: (
        <NavigationLayout>
          <AddEditUser mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/people/edit/departments",
      element: (
        <NavigationLayout>
          <Departments />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/brand-benchmark",
      element: (
        <NavigationLayout>
          <BrandBenchmark />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/brand-benchmark/new",
      element: (
        <NavigationLayout>
          <AddEditBrandBenchmark mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/brand-benchmark/:id",
      element: (
        <NavigationLayout>
          <AddEditBrandBenchmark mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/brand-benchmark/edit/criterias",
      element: (
        <NavigationLayout>
          <CriteriasBenchmark />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/brand-benchmark/edit/categories",
      element: (
        <NavigationLayout>
          <BrandBenchmarkCategories />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/brand-benchmark/:id/images",
      element: (
        <NavigationLayout>
          <ImagesBechmark />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/brand-benchmark/:id/images/new",
      element: (
        <NavigationLayout>
          <AddEditImageBechmark mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/brand-benchmark/:id/images/:screenshotId",
      element: (
        <NavigationLayout>
          <AddEditImageBechmark mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/countries",
      element: (
        <NavigationLayout>
          <CountriesSettings />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/projects",
      element: (
        <NavigationLayout>
          <MainProjects />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/projects/new",
      element: (
        <NavigationLayout>
          <ProjectAddEdit mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/projects/:id",
      element: (
        <NavigationLayout>
          <ProjectAddEdit mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/projects/types",
      element: (
        <NavigationLayout>
          <ProjectTypes />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/team",
      element: (
        <NavigationLayout>
          <Teams />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/task-manager/projects",
      element: (
        <NavigationLayout>
          <TaskManagerProjects />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/task-manager/projects-list",
      element: (
        <NavigationLayout>
          <ProjectsList />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/task-manager/projects/new",
      element: (
        <NavigationLayout>
          <ProjectTaskManagerAddEdit mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/task-manager/projects/:id",
      element: (
        <NavigationLayout>
          <ProjectTaskManagerAddEdit mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/task-manager/projects/:id/tasks",
      element: (
        <NavigationLayout>
          <TaskManagerMain />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/task-manager/projects/:id/tasks/new",
      element: (
        <NavigationLayout>
          <AddEditTaskManager mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/task-manager/projects/:id/tasks/:taskId",
      element: (
        <NavigationLayout>
          <AddEditTaskManager mode="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/task-manager/projects/:id/categories",
      element: (
        <NavigationLayout>
          <ProjectsTaskManagerCategories />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/task-manager/projects/:id/statuses",
      element: (
        <NavigationLayout>
          <ProjectsTaskManagerStatuses />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/task-manager/new",
      element: (
        <NavigationLayout>
          <AddEditTaskManager />
        </NavigationLayout>
      ),
    },
  ]);
}
export default App;
